import { render } from "./VinList.vue?vue&type=template&id=6f8bc38a&scoped=true"
import script from "./VinList.vue?vue&type=script&lang=js"
export * from "./VinList.vue?vue&type=script&lang=js"

import "./VinList.vue?vue&type=style&index=0&id=6f8bc38a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f8bc38a"]])

export default __exports__